export default "__VITE_ASSET__D$tGuNtU__"